import { GridActionsCellItem, GridColDef, GridRowParams, GridRowsProp } from '@mui/x-data-grid'
import { UserListApi } from '../../../models/user'
import { Box, Typography } from '@mui/material'
import CustomChip from '../../../../../shared/components/CustomChip'
import EditIcon from '@mui/icons-material/Edit'
import { deleteUser, showUser } from '../../../../../../redux/actions/users'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

export function useDependentsTable() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { dependents } = useSelector((state: IRootState) => state.user)

  const rows: GridRowsProp<UserListApi> = dependents ?? []
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 80, renderCell: (params: any) => `PL-${params.id}` },
    {
      field: 'name',
      headerName: t('name'),
      flex: 1,
      renderCell: (params: any) => (
        <Box display="flex" alignItems="center" gap={1}>
          <CustomChip size="small" color="primary" />
          <Typography>{params.value}</Typography>
        </Box>
      )
    },
    { headerName: t('rol'), field: 'role', flex: 1 },
    { headerName: t('email'), field: 'email', flex: 1 },
    {
      field: 'actions',
      type: 'actions',
      width: 30,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          key={params.id}
          icon={<EditIcon />}
          label={t('edit')}
          onClick={() => {
            dispatch(showUser(params.id))
          }}
          showInMenu
        />,
        <GridActionsCellItem
          key={params.id}
          icon={<DeleteIcon />}
          label={t('delete')}
          onClick={() => {
            dispatch(deleteUser(params.id))
          }}
          showInMenu
        />
      ]
    }
  ]

  return { rows, columns }
}
